// @flow

type TMapCalcState = {
    baseScale: number,
    currentZoom: number,
    hContainer: number,
    left: number,
    maxZoom: number,
    scale: number,
    top: number,
    wContainer: number,
};
const initialState: TMapCalcState = {
    baseScale: 1,
    currentZoom: 0,
    hContainer: 0,
    left: 0,
    maxZoom: 10,
    scale: 1,
    top: 0,
    wContainer: 0,
};

type TSetMapScale = {payload: number, type: 'SET_MAP_SCALE'};
type TSetBaseMapScale = {payload: number, type: 'SET_BASE_MAP_SCALE'};
type TIncMapZoom = {type: 'INC_MAP_ZOOM'};
type TDecMapZoom = {type: 'DEC_MAP_ZOOM'};
type TSetMapTop = {payload: number, type: 'SET_MAP_TOP'};
type TSetMapLeft = {payload: number, type: 'SET_MAP_LEFT'};
type TReturnToBase = {type: 'RETURN_TO_BASE'};
type TSetContainerHeight = {payload: number, type: 'SET_CONTAINER_HEIGHT'};
type TSetContainerWidth = {payload: number, type: 'SET_CONTAINER_WIDTH'};

type TMapActionList = TSetContainerWidth | TSetMapScale | TIncMapZoom | TDecMapZoom | TSetMapTop | TSetMapLeft | TReturnToBase | TSetContainerHeight;

function mapCalcReducer(state: TMapCalcState = initialState, {type, payload}: TMapActionList) {
    switch (type) {
        case 'DEC_MAP_ZOOM':
            return {
                ...state,
                currentZoom: state.currentZoom - 1,
            };

        case 'INC_MAP_ZOOM':
            return {
                ...state,
                currentZoom: state.currentZoom + 1,
            };
        case 'RETURN_TO_BASE':
            return {
                ...state,
                currentZoom: 0,
                left: 0,
                scale: state.baseScale,
                top: 0,
            };
        case 'SET_CONTAINER_HEIGHT':
            return {
                ...state,
                hContainer: payload,
            };
        case 'SET_CONTAINER_WIDTH':
            return {
                ...state,
                wContainer: payload,
            };
        case 'SET_MAP_TOP':
            return {
                ...state,
                top: payload,
            };
        case 'SET_MAP_LEFT':
            return {
                ...state,
                left: payload,
            };
        case 'SET_MAP_SCALE':
            return {
                ...state,
                scale: payload,
            };
        case 'SET_BASE_MAP_SCALE':
            return {
                ...state,
                baseScale: payload,
            };
        default:
            return state;
    }
}

export {mapCalcReducer};
export type {
    TMapCalcState,
    TSetMapScale,
    TIncMapZoom,
    TDecMapZoom,
    TSetBaseMapScale,
    TSetMapTop,
    TReturnToBase,
    TSetMapLeft,
    TSetContainerHeight,
    TSetContainerWidth,
};
